import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Map from '@/components/Map.vue'
import GuidePage from '@/components/GuidePage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  //base: process.env.environment === 'development' ? '/' : '/newfinder/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Map
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: About
    },
    {
      path: '/developer',
      name: 'developer',
      component: GuidePage
    },
/*    {
      path: '/dev',
      name: 'devMode',
      component: Map
    },
    {
      path: '/dev/:bldg',
      name: 'devBldg',
      component: Map
    },
    {
      path: '/dev/:bldg/:room',
      name: 'devRoom',
      component: Map
    },*/
    {
      path: '/highlight/:bldg',
      name: 'highlightBuilding', 
      component: Map
    },
    {
      path: '/highlight/:bldg/:room',
      name: 'highlightRoom', 
      component: Map
    },
  ]
})
